export default __webpack_public_path__ + "images/228294433a1c202e48288bc33ca1012e.svg";